
import { defineComponent } from 'vue';
import { AppCard, AppButton, AppImageHolder } from '@/components';
import { usePromotionPlanDetail } from '@/modules/promotion/plan/model/detail';
import { formatDate, renderTimeUnit, renderOption } from '@/common/utils/helpers';
import { Options } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PLAN.DETAIL,
    components: { AppCard, AppButton, AppImageHolder },
    setup() {
        const { model, actions } = usePromotionPlanDetail();

        return { model, actions, formatDate, Options, renderOption, renderTimeUnit, ROUTE_NAME_PROMOTION };
    }
});
